var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 60,
    viewBox: "0 0 63 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.3284 29.2295C62.3284 37.5747 58.6274 45.1495 53.1579 50.6147C47.6884 56.08 40.1137 60 31.7726 60C23.4316 60 17.1579 54.7832 11.6884 49.3137C6.21895 43.8442 0 37.5747 0 29.2295C0 20.8842 3.6 11.9958 9.06526 6.52632C14.5305 1.05684 23.4274 0 31.7726 0C40.1179 0 47.9453 2.12211 53.4147 7.59158C58.8842 13.0611 62.3284 20.8884 62.3284 29.2295Z",
    fill: "#FFA87D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3787 42C37.3183 42 43.8482 32.1082 43.8482 23.5305C43.8482 23.2491 43.8428 22.9691 43.8294 22.6917C45.0963 21.7748 46.199 20.6318 47.0674 19.3312C45.9041 19.8482 44.652 20.1956 43.3393 20.3531C44.6789 19.5493 45.7089 18.2783 46.1936 16.7623C44.9388 17.5055 43.5507 18.0468 42.0724 18.3376C40.8876 17.0747 39.2006 16.2857 37.3345 16.2857C33.7491 16.2857 30.8423 19.1925 30.8423 22.7765C30.8423 23.2855 30.8988 23.7809 31.0106 24.2562C25.6157 23.9856 20.8307 21.4019 17.6304 17.4745C17.073 18.4332 16.7512 19.548 16.7512 20.7368C16.7512 22.9893 17.897 24.9765 19.6405 26.1398C18.5755 26.1075 17.5752 25.814 16.7001 25.3279C16.6987 25.3548 16.6987 25.3818 16.6987 25.41C16.6987 28.5538 18.9364 31.1792 21.9065 31.7743C21.3612 31.9224 20.7876 32.0032 20.1952 32.0032C19.7765 32.0032 19.3699 31.9615 18.9754 31.8861C19.8021 34.4644 22.1986 36.3412 25.0395 36.3951C22.8166 38.1359 20.0175 39.174 16.9761 39.174C16.4523 39.174 15.9353 39.1443 15.4277 39.0838C18.3009 40.9242 21.7112 42 25.3787 42Z",
    fill: "#1E1010"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62.3284,
    height: 60,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.fef29bfff7a1d1dc2e05612fc137af4d.svg";
export { ForwardRef as ReactComponent };